<template>
  <div>
    <b-card v-if="vendorDetails.length == 0">
      <b-card-text class="text-center h-100">
        <h1>404. Please logout and login again to see data.</h1>
      </b-card-text>
    </b-card>
    <view-details v-if="vendorDetails" :vDetails="vendorDetails"></view-details>
    <upload-documents
      v-if="vendorDetails"
      :vDetails="vendorDetails"
    ></upload-documents>
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormText,
  BFormFile,
  BImg,
  BButton,
} from "bootstrap-vue";
import ViewDetails from "./ViewDetails.vue";
import UploadDocuments from "./UploadDocuments.vue";

export default {
  components: {
    BCard,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormText,
    BFormFile,
    BImg,
    BButton,
    ViewDetails,
    UploadDocuments,
  },
  data() {
    return {
      vendorDetails: this.$store.state.app.vendorDetails,
    };
  },
  mounted() {
    // console.log(this.vendorDetails);
  },
  methods: {},
};
</script>
